const TYPES = {
  PAGE_LOADED: 'ca.craver.web.page-loaded.v1',
  PAGE_EXITED: 'ca.craver.web.page-exited.v1',
};

export { TYPES };
